"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyToJSON = exports.SurveyFromJSONTyped = exports.SurveyFromJSON = exports.instanceOfSurvey = void 0;
var runtime_1 = require("../runtime");
var SurveyQuestion1_1 = require("./SurveyQuestion1");
/**
 * Check if a given object implements the Survey interface.
 */
function instanceOfSurvey(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurvey = instanceOfSurvey;
function SurveyFromJSON(json) {
    return SurveyFromJSONTyped(json, false);
}
exports.SurveyFromJSON = SurveyFromJSON;
function SurveyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'surveyQuestions': !(0, runtime_1.exists)(json, 'survey_questions') ? undefined : (json['survey_questions'].map(SurveyQuestion1_1.SurveyQuestion1FromJSON)),
    };
}
exports.SurveyFromJSONTyped = SurveyFromJSONTyped;
function SurveyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'survey_questions': value.surveyQuestions === undefined ? undefined : (value.surveyQuestions.map(SurveyQuestion1_1.SurveyQuestion1ToJSON)),
    };
}
exports.SurveyToJSON = SurveyToJSON;
